
import { Checkbox, FormControlLabel, FormGroup, Menu, Slider, Dialog, Button } from '@mui/material';
import * as turf from '@turf/turf';
import { getLegend, layerStatistics } from "api/layer";
import china from "assets/json/c1.json";
import Icon from "components/icon/icon";
import { AppAction, AppContext } from "helpers/context";
import { MapContext } from "helpers/map";
import { Children, MapLayer } from "helpers/models";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Expander from "../expander/expander";
import styles from "./layerList.module.scss";
import FathomIcon from "components/fathomIcon/fathomIcon";

let oversea = true;
let oversea1 = true;
let oversea2 = true;
let oversea3 = true;
let overseaFathom = true;
let chinaGeojson = turf.polygon(china.features[0].geometry.rings);

interface Props {
    inputFilter: string;
}

function Layers(props: Props) {
    const [context, dispatch] = useContext(AppContext);
    const { AMap, map } = useContext(MapContext);
    const [t] = useTranslation();
    const [layerList, setLayerList] = useState<MapLayer[]>(context.layerList || []);
    // const [oversea, setOversea] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [iconCurrent, setIconCurrent] = useState<any>(null);

    useEffect(() => {
        setLayerList(context.layerList || [])
    }, [context.layerList])

    useEffect(() => {
        if (map) {
            map.on(["complete", "moveend", "zoomend"], handleChangeOversea);
        }

        // 清理函数，移除事件监听器
        return () => {
            if (map) {
                map.off(["complete", "moveend", "zoomend"], handleChangeOversea);
            }
        };
    }, [map, layerList]);

    const handleChangeOversea = () => {
        let center = map.getCenter();
        let point = [center.lng, center.lat];
        let zoom = map.getZoom();
        
        let isChina = turf.booleanPointInPolygon(point, chinaGeojson)
        if (isChina) {
            /////100公里 除WS_Windspeed_Global_SwissRe（暴风）和CS_Lightning_Global_SwissRe（雷电）和fathom图层
            //zoom为7时 100公里比例尺 中心点在中国且比例尺在100公里内显示layerObjCn
            //WS_Windspeed_Global_SwissRe（暴风）和CS_Lightning_Global_SwissRe（雷电）特殊处理不做100公里判断
            if (oversea && zoom >= 7) {
                oversea = false;
                handleChangLayerDatas(false, "1")
            } else if (zoom < 7 && !oversea) {
                oversea = true;
                handleChangLayerDatas(true, "1")
            }

            /////大概3公里 WS_Windspeed_Global_SwissRe（暴风） 和EQ_Tsunami_SwissRe（海啸）
            //zoom为11.63时 3公里比例尺 中心点在中国且比例尺在3公里内显示layerObjCn
            if (oversea1 && zoom >= 11.63) {
                oversea1 = false;
                handleChangLayerDatas(false, "2")
            } else if (zoom < 11.63 && !oversea1) {
                oversea1 = true;
                handleChangLayerDatas(true, "2")
            }

            ////500米 fathom图层处理 和EQ_Tsunami_SwissRe（海啸）
            //zoom为14时 500米比例尺 中心点在中国且比例尺在500米内显示layerObjWms
            if (overseaFathom && zoom >= 14) {
                overseaFathom = false;
                handleChangLayerDatas(false, "3")
            } else if (zoom < 14 && !overseaFathom) {
                overseaFathom = true;
                handleChangLayerDatas(true, "3")
            }

            /////5公里 EQ_Landslide_Global_SwissRe（滑坡）图层处理
            /////zoom为10.72时 5公里比例尺 中心点在中国且比例尺在5公里内显示layerObjWms
            if (oversea2 && zoom >= 10.72) {
                oversea2 = false;
                handleChangLayerDatas(false, "4")
            } else if (zoom < 10.72 && !oversea2) {
                oversea2 = true;
                handleChangLayerDatas(true, "4")
            }

            /////大概10公里CS_Lightning_Global_SwissRe（雷电）
            ///////zoom为9.66时 10公里比例尺  中心点在中国且比例尺在3公里内显示layerObjCn
            if (oversea3 && zoom >= 9.66) {
                oversea3 = false;
                handleChangLayerDatas(false, "5")
            } else if (zoom < 9.66 && !oversea3) {
                oversea3 = true;
                handleChangLayerDatas(true, "5")
            }
        } else {
            oversea = true;
            oversea1 = true;
            overseaFathom = true;
            handleChangLayerDatas(true, "0")
        }
    }

    const handleChangLayerDatas = (is: boolean, type: string) => {
        layerList.forEach(item => {
            item.children.forEach(v => {
                if (v.checked) {
                    if (type === "1") {
                        if (v.id !== "WS_Windspeed_Global_SwissRe" && v.id !== "CS_Lightning_Global_SwissRe" && v.id !== "EQ_Tsunami_SwissRe") {
                            if (is) {
                                v.layerObjEn.show()
                                v.layerObjCn.hide()
                                v.layerObjWms && v.layerObjWms.hide()
                            } else {
                                v.layerObjEn.hide()
                                v.layerObjCn.show()
                                v.layerObjWms && v.layerObjWms.hide()
                            }
                        }
                    } else if (type === "2") {
                        if (v.id === "WS_Windspeed_Global_SwissRe" || v.id === "EQ_Tsunami_SwissRe") {
                            if (is) {
                                v.layerObjEn.show()
                                v.layerObjCn.hide()
                            } else {
                                v.layerObjEn.hide()
                                v.layerObjCn.show()
                            }
                        }
                    } else if (type === "3") {
                        if (v.id.includes("Fathom") || v.id === "EQ_Tsunami_SwissRe") {
                            if (is) {
                                v.layerObjEn.hide()
                                v.layerObjCn.show()
                                v.layerObjWms.hide()
                            } else {
                                v.layerObjEn.hide()
                                v.layerObjCn.hide()
                                v.layerObjWms.show()
                            }
                        }
                    } else if (type === "4") {
                        if (v.id === "EQ_Landslide_Global_SwissRe") {
                            if (is) {
                                v.layerObjEn.hide()
                                v.layerObjCn.show()
                                v.layerObjWms.hide()
                            } else {
                                v.layerObjEn.hide()
                                v.layerObjCn.hide()
                                v.layerObjWms.show()
                            }
                        }
                    } else if (type === "5") {
                        if (v.id === "CS_Lightning_Global_SwissRe") {
                            if (is) {
                                v.layerObjEn.show()
                                v.layerObjCn.hide()
                            } else {
                                v.layerObjEn.hide()
                                v.layerObjCn.show()
                            }
                        }
                    } else {
                        v.layerObjEn.show()
                        v.layerObjCn && v.layerObjCn.hide()
                        v.layerObjWms && v.layerObjWms.hide()
                    }
                }
            })
        });
    }

    // 02转84墨卡托
    const GCJLL_to_WGS84LL = (lng: any, lat: any) => {
        const transformlat = (lng: any, lat: any) => {
            let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
            ret += (20.0 * Math.sin(6.0 * lng * pi) + 20.0 * Math.sin(2.0 * lng * pi)) * 2.0 / 3.0;
            ret += (20.0 * Math.sin(lat * pi) + 40.0 * Math.sin(lat / 3.0 * pi)) * 2.0 / 3.0;
            ret += (160.0 * Math.sin(lat / 12.0 * pi) + 320 * Math.sin(lat * pi / 30.0)) * 2.0 / 3.0;
            return ret;
        }

        const transformlng = (lng: any, lat: any) => {
            let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
            ret += (20.0 * Math.sin(6.0 * lng * pi) + 20.0 * Math.sin(2.0 * lng * pi)) * 2.0 / 3.0;
            ret += (20.0 * Math.sin(lng * pi) + 40.0 * Math.sin(lng / 3.0 * pi)) * 2.0 / 3.0;
            ret += (150.0 * Math.sin(lng / 12.0 * pi) + 300.0 * Math.sin(lng / 30.0 * pi)) * 2.0 / 3.0;
            return ret;
        }

        const out_of_china = (lng: any, lat: any) => {
            if (lng < 72.004 || lng > 137.8347) {
                return true;
            }
            if (lat < 0.8293 || lat > 55.8271) {
                return true;
            }
            return false;
        }

        const WGS84_to_3857 = (lng: any, lat: any) => {
            const x = lng * 20037508.342789 / 180;
            let y = Math.log(Math.tan((90 + lat) * Math.PI / 360)) / (Math.PI / 180);
            y = y * 20037508.34789 / 180;
            return { lon: x, lat: y };
        }

        const pi = 3.1415926535897932384626;
        const a = 6378245.0; // 长半轴
        const ee = 0.00669342162296594323; // 扁率

        if (out_of_china(lng, lat)) {
            return { longitude: lng, latitude: lat };
        }

        let dlat = transformlat(lng - 105.0, lat - 35.0);
        let dlng = transformlng(lng - 105.0, lat - 35.0);
        let radlat = lat / 180.0 * pi;
        let magic = Math.sin(radlat);
        magic = 1 - ee * magic * magic;
        let sqrtmagic = Math.sqrt(magic);
        dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * pi);
        dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * pi);
        let mglat = lat + dlat;
        let mglng = lng + dlng;

        return WGS84_to_3857(lng * 2 - mglng, lat * 2 - mglat);


    }

    // 行号转经度
    const tile2lon = (x: any, z: any) => {
        return (x / Math.pow(2, z) * 360 - 180);
    }

    // 列号转纬度
    const tile2lat = (y: any, z: any) => {
        let n = Math.PI - 2 * Math.PI * y / Math.pow(2, z);
        return (180 / Math.PI * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n))));
    }

    const handleCheckLayer = (layerInfo: Children) => {
        let layerLength = 0
        layerList.forEach(item => {
            layerLength += item.children.filter(v => v.checked).length
        });

        if (layerLength >= 5 && !layerInfo.checked) {
            dispatch({
                type: AppAction.addSnackBarParams,
                payload: {
                    title: "limitAlert",
                    titleIcon: "error",
                    titleIconColor: "#fff"
                }
            })
            return;
        }

        handleChangeOversea()
        layerInfo.checked = !layerInfo.checked;

        if (layerInfo.checked) {
            layerStatistics({
                eventType: "risklayer",
                perils: layerInfo.id.includes("Fathom") ? "fathom" : "catnet",
                layers: layerInfo.id,
                layerAmount: 1,
                status: "1",
            })

            if (layerInfo.layerObjEn) {
                if (layerInfo.id === "WS_Windspeed_Global_SwissRe" || layerInfo.id === "CS_Lightning_Global_SwissRe") {
                    if (oversea1) {
                        layerInfo.layerObjEn.show()
                        layerInfo.layerObjCn.hide()
                    } else {
                        layerInfo.layerObjEn.hide()
                        layerInfo.layerObjCn.show()
                    }
                } else if (layerInfo.id === "CS_Lightning_Global_SwissRe") {
                    if (oversea3) {
                        layerInfo.layerObjEn.show()
                        layerInfo.layerObjCn.hide()
                    } else {
                        layerInfo.layerObjEn.hide()
                        layerInfo.layerObjCn.show()
                    }
                } else {
                    if (layerInfo.id.includes("Fathom")) {
                        if (oversea) {
                            layerInfo.layerObjEn.show()
                            layerInfo.layerObjCn.hide()
                            layerInfo.layerObjWms.hide()
                        } else if (overseaFathom) {
                            layerInfo.layerObjEn.hide()
                            layerInfo.layerObjCn.show()
                            layerInfo.layerObjWms.hide()
                        } else {
                            layerInfo.layerObjEn.hide()
                            layerInfo.layerObjCn.hide()
                            layerInfo.layerObjWms.show()
                        }
                    } else if (layerInfo.id === "EQ_Tsunami_SwissRe") {
                        if (oversea1) {
                            layerInfo.layerObjEn.show()
                            layerInfo.layerObjCn.hide()
                            layerInfo.layerObjWms.hide()
                        } else if (overseaFathom) {
                            layerInfo.layerObjEn.hide()
                            layerInfo.layerObjCn.show()
                            layerInfo.layerObjWms.hide()
                        } else {
                            layerInfo.layerObjEn.hide()
                            layerInfo.layerObjCn.hide()
                            layerInfo.layerObjWms.show()
                        }
                    } else if (layerInfo.id === "EQ_Landslide_Global_SwissRe") {
                        if (oversea) {
                            layerInfo.layerObjEn.show()
                            layerInfo.layerObjCn.hide()
                            layerInfo.layerObjWms.hide()
                        } else if (oversea2) {
                            layerInfo.layerObjEn.hide()
                            layerInfo.layerObjCn.show()
                            layerInfo.layerObjWms.hide()
                        } else {
                            layerInfo.layerObjEn.hide()
                            layerInfo.layerObjCn.hide()
                            layerInfo.layerObjWms.show()
                        }
                    } else {
                        if (oversea) {
                            layerInfo.layerObjEn.show()
                            layerInfo.layerObjCn.hide()
                        } else {
                            layerInfo.layerObjEn.hide()
                            layerInfo.layerObjCn.show()
                        }
                    }

                }
                dispatch({ type: AppAction.updateLayerLegend, payload: layerInfo });
            } else {
                //国外瓦片和国内2-7级瓦片  oversea true 代表国外
                let layerObjEn = new AMap.TileLayer({
                    tileUrl: `${(window as any).amapLayerUrl}/risklayer-api/catnet-cn/tilesEx/${layerInfo.id}/tile/[z]/[x]/[y]?X-Token=${sessionStorage.getItem("token")}&oversea=true`,
                    opacity: layerInfo.opacity,
                });
                layerInfo.layerObjEn = layerObjEn;
                map.addLayer(layerObjEn);

                //国内7级以上瓦片 oversea false代表国内7级以上   oversea1 false 代表国内11.63级以上
                let layerObjCn = new AMap.TileLayer({
                    tileUrl: `${(window as any).amapLayerUrl}/risklayer-api/catnet-cn/tilesEx/${layerInfo.id}/tile/[z]/[y]/[x]?X-Token=${sessionStorage.getItem("token")}&oversea=false`,
                    opacity: layerInfo.opacity,
                });
                layerInfo.layerObjCn = layerObjCn;
                map.addLayer(layerObjCn);

                //国内14级以上的fathom图层 overseaFathom代表国内14级以上
                if (layerInfo.id.includes("Fathom") || layerInfo.id === "EQ_Landslide_Global_SwissRe" || layerInfo.id === "EQ_Tsunami_SwissRe") {
                    let layerWms = new AMap.TileLayer({
                        tileSize: 256,
                        opacity: layerInfo.opacity,
                        getTileUrl: (x: any, y: any, z: any) => {
                            // 行列号转经纬度
                            let xmin = tile2lon(x, z);
                            let xmax = tile2lon(x + 1, z);
                            let ymin = tile2lat(y + 1, z);
                            let ymax = tile2lat(y, z);
                            // 经纬度转纠偏+转墨卡托
                            let x_y_min_84: any = GCJLL_to_WGS84LL(xmin, ymin)
                            let x_y_max_84: any = GCJLL_to_WGS84LL(xmax, ymax)

                            // 拼接WMS请求
                            // let url = 'https://tile.catnet.swissre.cn/server/services/risk_china/FL_PLUVIAL_Global_Fathom_WMS_box3857/MapServer/WMSServer?';
                            let url = `${(window as any).amapLayerUrl}/risklayer-api/catnet-cn/wms/${layerInfo.id}_D/WMSServer?`;
                            let params: any = {
                                service: "WMS",
                                version: "1.1.0",
                                transparent: true,
                                request: "GetMap",
                                layers: 0,
                                width: 256,
                                height: 256,
                                styles: '',
                                srs: "EPSG:3857",
                                format: "image/png",
                                bbox: [x_y_min_84.lon, x_y_min_84.lat, x_y_max_84.lon, x_y_max_84.lat].join(','),
                                "X-Token": sessionStorage.getItem("token")
                            };

                            return (url + new URLSearchParams(params).toString());
                        },
                    });
                    layerInfo.layerObjWms = layerWms;
                    map.addLayer(layerWms);
                }

                if (layerInfo.id === "WS_Windspeed_Global_SwissRe") {
                    if (oversea1) {
                        layerInfo.layerObjCn.hide()
                    } else {
                        layerInfo.layerObjEn.hide()
                    }
                } else if (layerInfo.id === "CS_Lightning_Global_SwissRe") {
                    if (oversea3) {
                        layerInfo.layerObjCn.hide()
                    } else {
                        layerInfo.layerObjEn.hide()
                    }
                } else if (layerInfo.id.includes("Fathom")) {
                    if (oversea) {
                        layerInfo.layerObjCn.hide()
                        layerInfo.layerObjWms.hide()
                    } else if (overseaFathom) {
                        layerInfo.layerObjEn.hide()
                        layerInfo.layerObjWms.hide()
                    } else {
                        layerInfo.layerObjEn.hide()
                        layerInfo.layerObjCn.hide()
                    }
                } else if (layerInfo.id === "EQ_Tsunami_SwissRe") {
                    if (oversea1) {
                        layerInfo.layerObjCn.hide()
                        layerInfo.layerObjWms.hide()
                    } else if (overseaFathom) {
                        layerInfo.layerObjEn.hide()
                        layerInfo.layerObjWms.hide()
                    } else {
                        layerInfo.layerObjEn.hide()
                        layerInfo.layerObjCn.hide()
                    }
                } else if (layerInfo.id === "EQ_Landslide_Global_SwissRe") {
                    if (oversea) {
                        layerInfo.layerObjCn.hide()
                        layerInfo.layerObjWms.hide()
                    } else if (oversea2) {
                        layerInfo.layerObjEn.hide()
                        layerInfo.layerObjWms.hide()
                    } else {
                        layerInfo.layerObjEn.hide()
                        layerInfo.layerObjCn.hide()
                    }
                } else {
                    if (oversea) {
                        layerInfo.layerObjCn.hide()
                    } else {
                        layerInfo.layerObjEn.hide()
                    }
                }
                getLegend(layerInfo.id).then(async (res: any) => {
                    dispatch({ type: AppAction.addLayerLegend, payload: { ...res.data, layerInfo } })
                });
            }
        } else {
            layerInfo.layerObjEn.hide()
            layerInfo.layerObjCn && layerInfo.layerObjCn.hide()
            layerInfo.layerObjWms && layerInfo.layerObjWms.hide()
            dispatch({ type: AppAction.updateLayerLegend, payload: layerInfo });
        }

        let layers = layerList.map((item: any) => {
            item.children = item.children.map((i: any) => {
                if (i.id === layerInfo.id) {
                    i = layerInfo;
                }
                return i
            })
            return item
        });

        // setLayerList(layers)
        dispatch({ type: AppAction.setLayerList, payload: layers });

    };

    const handleChangeOpacity = (event: any, value: any) => {
        let layerInfo = { ...iconCurrent, opacity: value };
        let list = layerList!.map((layer) => {
            if (layer.name === layerInfo.group) {
                layer.children = layer.children.map((layerItem) => {
                    if (layerItem.id === layerInfo.id) {
                        layerItem.opacity = value;
                        layerItem.layerObjEn && layerItem.layerObjEn.setOpacity(value);
                        layerItem.layerObjCn && layerItem.layerObjCn.setOpacity(value);
                        layerItem.layerObjWms && layerItem.layerObjWms.setOpacity(value);
                    }
                    return layerItem;
                })
            }
            return layer;
        });
        dispatch({ type: AppAction.setLayerList, payload: list });
        setLayerList(list);
        setIconCurrent(layerInfo);
    }

    const toggleLayerInfo = (layerInfo: Children) => {
        dispatch({
            type: AppAction.setLayerInfoModal,
            payload: layerInfo,
        });
    };

    return (
        <div className={styles.perils}>
            {(layerList.length > 0) &&
                layerList.map((layer, index) => (
                    (layer.children.filter(v => (t("layers.item." + v.name).toLowerCase()).indexOf(props.inputFilter.toLowerCase()) > -1).length) > 0 && (
                        <Expander
                            key={index}
                            title={t("layers.group." + layer.name)}
                            count={layer.children.length}
                        >
                            {layer.children.map((item, i) => (
                                (t("layers.item." + item.name).toLowerCase()).indexOf(props.inputFilter.toLowerCase()) > -1 &&
                                (<div
                                    // className={
                                    //   !item.onClick ? styles.checkboxDisabled : styles.checkbox
                                    // }
                                    key={i}
                                    className={styles.checkbox}
                                    style={{ backgroundColor: iconCurrent && (iconCurrent.id === item.id) ? "var(--gray-hover)" : "" }}
                                >
                                    <FormGroup
                                        onChange={() => handleCheckLayer(item)}
                                        onClick={() => {
                                            if (item.id.includes("Fathom") && !context.menu.find((item) => item.id === "101002" && item.status === "1")) {
                                                dispatch({ type: AppAction.setFathomPermissionDialog, payload: true });
                                            }
                                        }}
                                        sx={{
                                            flex: "1",
                                            "& .MuiFormControlLabel-label": {
                                                flex: "1",
                                            }
                                        }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled={item.id.includes("Fathom") ? !context.menu.find((item) => item.id === "101002" && item.status === "1") : !context.menu.find((item) => item.id === "101001" && item.status === "1")}
                                                    checked={item.checked}
                                                    color="success"
                                                />
                                            }
                                            label={(
                                                <div className='text-[13px] font-normal flex items-center'>
                                                    <span className='flex-1'>{t("layers.item." + item.name)}</span>
                                                    {item.id.includes("Fathom") && <FathomIcon className={styles.premium} />}
                                                </div>
                                            )}
                                        />
                                    </FormGroup>
                                    <div
                                        className={styles.icons}
                                        onClick={(evt) => evt.stopPropagation()}
                                        style={{ display: iconCurrent && (iconCurrent.id === item.id) ? "flex" : "" }}
                                    >
                                        <Icon
                                            icon="info"
                                            type="outlined"
                                            onClick={() =>
                                                toggleLayerInfo({
                                                    name: t("layers.item." + item.name),
                                                    id: item.id,
                                                    group: item.group,
                                                    category: item.category,
                                                    description: t("layers.description." + item.name),
                                                })
                                            }
                                        />

                                        <Icon
                                            icon="opacity"
                                            onClick={(event) => {
                                                setIconCurrent(item)
                                                setAnchorEl(event.currentTarget);
                                            }}
                                        />
                                    </div>
                                </div>
                                )))}
                        </Expander>)
                ))}
            {iconCurrent && <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => {
                    setIconCurrent(null);
                    setAnchorEl(null);
                }}
            >
                <div className="px-4 py-2 w-[200px]">
                    <div className="text-[14px] my-[4px]">{t("layers.opacity")}: {(iconCurrent.opacity * 100).toFixed(0)}%</div>
                    <Slider
                        value={iconCurrent.opacity}
                        size="small"
                        max={1}
                        min={0}
                        step={0.01}
                        color="success"
                        onChange={handleChangeOpacity}
                    // sx={{
                    //     "& .MuiSlider-thumb:hover": {
                    //         boxShadow: "none",
                    //         // transform: "scale(1)",
                    //     }
                    // }}
                    />
                </div>
            </Menu>}
        </div>
    );
}

export default Layers;
